import api from "../index";

export const GetAllAccountApi = (params) => api.get(`Admin/GetAll-MT5LiveAccount?${params}`);
export const MT5RequestAcceptRejectApi = (data) => api.post('Admin/MT5LiveAcc-RejectedApproved', data);
export const GetAllMT5ByIdApi = (MT5Id) => api.get(`MTFiveAccount/UserGetSingle-LiveAccount/${MT5Id}`);
export const GetAllOnlineUsersApi = (params) => api.get(`Admin/Get-Online-User-Detail?${params}`);
export const GetAllInactiveAccounts = (params) => api.get(`Admin/Get-InActive-User-Detail?${params}`);

export const GetAllDemoAccountApi = (params) => api.get(`Admin/GetAll-MT5DemoAccount?${params}`);

export const SyncMT5Account = (data) => api.post('Admin/MTAccount-bind-with-User', data);
export const GetAcountDetailsByLoginId = (loginId) => api.get(`MTFiveAccount/Get-Account-Details?LoginId=${loginId}`);
export const SetMT5AutoTransferApprovalApi = (data) => api.put('Admin/Set-MT5-Account-Auto-Transfer-Approval', data);
export const GetAllOpenTradesApi = (params) => api.get(`MTFiveAccount/GetAll-Open-Trades?${params}`);
export const GetAllClosedTradesApi = (params) => api.get(`MTFiveAccount/GetAll-Closed-Trades?${params}`);